// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--pa6LS";
export var item = "styles-module--item--QbiLC";
export var itemActive = "styles-module--itemActive--t7RKv";
export var title = "styles-module--title--nxnCG";